export const recipientTypes = {
  nonprofit: ['Recipient Information'],
  candidate: ['Recipient Information', 'Race Information'],
};

export const TypeOptions = [
  { label: 'Organization', value: 'ORGANIZATION' },
  { label: 'Candidate', value: 'CANDIDATE' },
];

export const SubtypeOptions = [
  { label: '501(c)(3)', value: '501C3' },
  { label: '501(c)(4)', value: '501C4' },
  { label: 'PAC', value: 'PAC' },
  { label: 'Party', value: 'PARTY' },
  { label: '527', value: '527_ORG' },
];

export const CandidateSubtypeOptions = [
  { label: 'Democrat', value: 'DEMOCRAT' },
  { label: 'Independent', value: 'INDEPENDENT' },
];

export const RecipientStatusOptions = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Paused', value: 'PAUSED' },
];

export const DeStatusOptions = [
  { label: '-', value: '' },
  { label: 'Pending', value: 'PENDING' },
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' },
  { label: 'Comp Race', value: 'COMP_RACE' },
  { label: 'Paused', value: 'PAUSED' },
];
